exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pdfFiles{border-bottom:none!important}.pdfFiles .show-deleted-checkbox{text-transform:lowercase;font-weight:400}.bg-disable{background:#d3d3d3}", ""]);

// exports
